import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { PublicRoute } from '../components/PublicRoute';
import Layout from '../shared/components/Layout';
import { publicRoutes, protectedRoutes } from './routeConfig';
import GuestPaymentPage from '../features/payment/GuestPaymentPage';

const AppRoutesWithConfig = () => {
  return (
    <Routes>
      {/* Guest Payment Routes — no auth wrapper */}
      <Route path="/pay/:token" element={<GuestPaymentPage />} />
      <Route path="/admin/pay/:token" element={<GuestPaymentPage />} />

      {/* Public Routes */}
      {publicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={
            <PublicRoute>
              <route.component />
            </PublicRoute>
          }
        />
      ))}

      {/* Protected Routes with Layout */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {protectedRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>

      {/* Default Route */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* 404 Route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutesWithConfig;